<template>
  <DatePicker
    v-model="date"
    :label="$tt('last_visa_issue_date')"
    :hint="$tt('estimate_date')"
    past
  />
</template>

<script setup lang="ts">
import type { DateISO } from '~/types';
const date = defineModel<DateISO>({ required: true });
</script>